import React from 'react';
import Account from "../helpers/Account.js";
import images from "../assets/img/images.jpg";
import {Link} from "react-router-dom";

const {profession} = Account.getData()

const OrganizationItem = ({ id, logo, orgname, is_deleted, name, surname, HVHH, phone, accountant_list }) => {


    const handleDelete = async () => {
        await Api.deleteCompanies({id})
        // delete_company({ id });
    };

    return (
        <div className='list-item'>
            <Link to={profession !== "manager" ? `/main_employee/organization_file/?company=${id}` : ""}>
                <div className='list-item-img'
                     style={{ backgroundImage: logo ? `url(${logo})` : `url(${images})` }}>
                </div>
            </Link>
            <div className='list-item-data'>
                <Link to={`/main_employee/organization/${id}`}>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">{orgname}</div>
                        <div className='list-item-name-surname'>
                            {orgname} {is_deleted && <i className="fas fa-trash-alt" onClick={handleDelete}/>}
                        </div>
                    </div>
                </Link>
                <div>
                    <div className='line'/>
                    <span className='list-item-name-surname'>{name}</span>
                    <span className='list-item-name-surname'>{surname}</span>
                    <p className='profession'>{HVHH}</p>
                    <p className='numbers'>{phone}</p>
                </div>
            </div>
            <div className="accountant_image_list">
                {accountant_list && accountant_list.map((item, index) => (
                    <div key={index} className="accountant_image"
                         style={{ backgroundImage: item.image ? `url(${item.image})` : "url( )" }}>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OrganizationItem;
